// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mpi-module_mpiFrame__Pmw5L {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
}

.mpi-module_redirectFrame__fYigv {
    flex: 1;
    display: flex;
    width: 100%;
}

.mpi-module_collectFrame__BvI_3 {
    visibility: collapse;
    width: 100%;
}

.mpi-module_frame__UHtb7 {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Mpi/mpi.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":[".mpiFrame {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    align-items: center;\n}\n\n.redirectFrame {\n    flex: 1;\n    display: flex;\n    width: 100%;\n}\n\n.collectFrame {\n    visibility: collapse;\n    width: 100%;\n}\n\n.frame {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mpiFrame": `mpi-module_mpiFrame__Pmw5L`,
	"redirectFrame": `mpi-module_redirectFrame__fYigv`,
	"collectFrame": `mpi-module_collectFrame__BvI_3`,
	"frame": `mpi-module_frame__UHtb7`
};
export default ___CSS_LOADER_EXPORT___;
